import { IconButton, Skeleton, Stack, TableCell, Tooltip, Typography } from '@mui/material';
import { AssignedDoctorsCells, getPatientTreatments, TreatmentsCells } from 'framework/user';
import useFetchSection from 'hooks/useFetchSection';
import List from '../List';
import EmptyContent from 'components/EmptyContent';
import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";
import { ITreatments } from 'models/user';
import { formatDate } from 'helpers';
import { RemoveRedEye } from "@mui/icons-material";
import { useNavigate } from 'react-router-dom';

interface Props {
    slugId: string
}
function Treatments({ slugId }: Props) {

    const navigate = useNavigate();

    const {
        loading,
        data: Treatments,
        error,
        revalidate,
    } = useFetchSection({
        fetchData: () => getPatientTreatments(slugId),
        fetchPermission: async () => null,
        section: "Patient Treatments"
    });

    if (loading)
        return (
            <Stack spacing={2} p={2}>
                {Array.from({ length: 10 }).map((_, i) => (
                    <Skeleton variant="rectangular" key={i} width="100%" height={30} />
                ))}
            </Stack>
        );

    const getBodyCells = (row: ITreatments) => {
        let cells = Object.keys(row).map((key: string, i: number) => {

            if (key === "TreatmentID")
                return {
                    id: "action",
                    element: (
                        <TableCell align={"left"} key={i}>
                            <Stack
                                direction={"row"}
                                alignContent={"center"}
                                spacing={1}
                            >
                                <Tooltip title={`Go to Treatments Details`}>
                                    <IconButton
                                        size={"small"}
                                        sx={{
                                            color: "#9e9e52",
                                        }}
                                        onClick={() => navigate(`/treatments/${row.TreatmentID}`)}
                                    >
                                        <RemoveRedEye />
                                    </IconButton>
                                </Tooltip>
                            </Stack>
                        </TableCell>),
                };

            if (key === "StartDate")
                return {
                    id: "StartDate",
                    element: (
                        <TableCell align={"left"} key={i}>
                            <Typography variant="body2">{formatDate(row?.StartDate)}</Typography>
                        </TableCell>
                    ),
                };
            if (key === "Duration")
                return {
                    id: "Duration",
                    element: (
                        <TableCell align={"left"} key={i}>
                            <Typography variant="body2">{row?.Duration}</Typography>
                        </TableCell>
                    ),
                };

            if (key === "CurrentStatus")
                return {
                    id: "CurrentStatus",
                    element: (
                        <TableCell align={"left"} key={i}>
                            <Typography variant="body2">{row?.CurrentStatus}</Typography>
                        </TableCell>
                    ),
                };

            if (key === "AlignersCount")
                return {
                    id: "AlignersCount",
                    element: (
                        <TableCell align={"left"} key={i}>
                            <Typography variant="body2">{row?.AlignersCount}</Typography>
                        </TableCell>
                    ),
                };

            if (key === "GoalInHours")
                return {
                    id: "GoalInHours",
                    element: (
                        <TableCell align={"left"} key={i}>
                            <Typography variant="body2">{row?.GoalInHours}</Typography>
                        </TableCell>
                    ),
                };

            if (key === "ImageUploadFrequency")
                return {
                    id: "ImageUploadFrequency",
                    element: (
                        <TableCell align={"left"} key={i}>
                            <Typography variant="body2">{row?.ImageUploadFrequency}</Typography>
                        </TableCell>
                    ),
                };

        });
        return cells;
    };


    return (
        <div>
            {Treatments!.length > 0 && (
                <List
                    headCells={TreatmentsCells}
                    data={Treatments!}
                    getBodyCells={getBodyCells}
                    canEdit={false}
                />
            )}
            {(!Treatments || Treatments.length === 0) &&

                <EmptyContent
                    icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
                    header={"No Patient Treatments"}
                    message={`No Patient Treatment Yet`}
                />
            }
        </div>
    )
}

export default Treatments